import React, { useState } from 'react';
import { useWorkLogs, useCreateWorkLog } from 'service/project/hooks/useWorkLog';
import { formatTimeSpent } from 'utils/timeTracking';
import LogTimeModal from 'components/Modals/LogTimeModal';
import { useAppSelector } from 'store';
import { selectAuthUser } from 'store/slices/auth/auth.selector';

interface TimeTrackerSidebarProps {
  projectId: string;
  taskId: string;
}

const TimeTrackerSidebar: React.FC<TimeTrackerSidebarProps> = ({ projectId, taskId }) => {
  const { data: logs = [], isLoading } = useWorkLogs(projectId, taskId);
  const { mutate: createLog } = useCreateWorkLog();
  const [modalOpen, setModalOpen] = useState(false);
  const authUser = useAppSelector(selectAuthUser);

  // Calculate total time (overall for the task across all users)
  const totalMinutes = (logs as any[]).reduce((acc: number, log: any) => acc + (log.minutesSpent || 0), 0);

  // Filter logs for the current user to pass to the modal for daily limit validation
  const userLogs = (logs as any[]).filter(log => log.loggedByAppUserUuid === authUser?.appUserUuid);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-neutral-medium">
          Time Tracking
        </label>
      
      </div>
      
      <div className="flex items-center justify-between gap-4">
        <div>
          <div className="text-lg font-semibold text-white tracking-tight">
            {isLoading ? '...' : formatTimeSpent(totalMinutes)}
          </div>
          <div className="text-[11px] tracking-wider text-neutral-medium font-medium mt-0.5">Total logged</div>
        </div>  <button
          onClick={() => setModalOpen(true)}
          className="relative group p-[1px] rounded-lg transition-all active:scale-95 overflow-hidden"
        >
          {/* Gradient Border Background */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#7C3AED] to-[#3B82F6] opacity-90 group-hover:opacity-100 transition-opacity" />
          
          {/* Inner Content with Background */}
          <div className="relative bg-[#1a1b23] px-3 py-1.5 rounded-[7px] flex items-center justify-center">
            <span className="text-xs  text-[#9B8EF0] transition-colors">
              + Log Time
            </span>
          </div>
        </button>
      </div>

      <LogTimeModal
        isOpen={modalOpen}
        existingUserLogs={userLogs}
        onClose={() => setModalOpen(false)}
        onSave={(data) => {
          createLog({
            projectUuid: projectId,
            workItemUuid: taskId,
            dateStarted: data.dateStarted,
            timeSpent: data.timeSpentStr,
            description: data.description,
          });
          setModalOpen(false);
        }}
      />
    </div>
  );
};

export default TimeTrackerSidebar;
